import { render, staticRenderFns } from "./profilesInfo.vue?vue&type=template&id=cf1d37a4&scoped=true&"
import script from "./profilesInfo.vue?vue&type=script&lang=js&"
export * from "./profilesInfo.vue?vue&type=script&lang=js&"
import style1 from "./profilesInfo.vue?vue&type=style&index=1&id=cf1d37a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1d37a4",
  null
  
)

export default component.exports